import React, { Component } from "react";
import { connect } from "react-redux";
import * as postActions from "../../../store/action/post";
import localStorage from "../../../utils/local-storage";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import * as _ from "lodash";
import { useEffect, useState } from "react";
import { confirm } from 'src/utils/confirm';

const OptionsTab = (props) => {
  const {
    layoutName,
    post: { currentPost },
    nhaycamInfo,
  } = props;

  const [post_ads, setPost_ads] = useState(true);
  const [off_comment, setOff_comment] = useState(false);
  const [log_action, setLog_action] = useState("");
  const [nhaycamStatus, setNhaycamStatus] = useState(false);

  const changeStatusPostOptions = (check, field) => {
    if (field === "post_ads") {
      setPost_ads(check);
      currentPost.post_ads = check;
      props.setCurrentPost(currentPost);
    }

    if (field === "off_comment") {
      setOff_comment(check);
      currentPost.off_comment = check;
      props.setCurrentPost(currentPost);
    }
  };

  useEffect(() => {
    if (typeof props.post.currentPost.log_action === "string") {
      const logAction = props.post.currentPost.log_action.split(",");
      setLog_action(logAction);
    } else {
      if (props.post.currentPost.log_action) {
        props.post.currentPost.log_action.then((data) => {
          if (data) {
            const logAction = data.split(",");
            setLog_action(logAction);
          }
        });
      }
    }
    setPost_ads(currentPost.post_ads);
    setOff_comment(currentPost.off_comment);
  }, []);

  useEffect(() => {
    if (nhaycamInfo) {
      setNhaycamStatus(true);
    } 
  }, [nhaycamInfo]);

  return (
    <>
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 "}>
            <h4 className="card-title">Tuỳ chỉnh</h4>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        )}

        <div className="card-body col-12">
          <div className="d-flex justify-content-between">
            <span className="mr-2">Quảng cáo</span>

            <BootstrapSwitchButton
              checked={post_ads}
              onChange={(check) => {
                changeStatusPostOptions(check, "post_ads");
              }}
              onstyle="success"
              onlabel="Bật"
              offlabel="Tắt"
              offstyle="light"
              size="sm"
              width="80"
            />
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <span className="mr-2">Tắt Comment</span>

            <BootstrapSwitchButton
              checked={off_comment}
              onChange={(check) => {
                changeStatusPostOptions(check, "off_comment");
              }}
              onstyle="success"
              onlabel="Bật"
              offlabel="Tắt"
              offstyle="light"
              size="sm"
              width="80"
            />
          </div>
        </div>
      </div>
      <div className={layoutName !== "layout-pc" ? "row card" : ""}>
        {layoutName !== "layout-pc" && (
          <div className={"card-header col-12 "}>
            <h4 className="card-title">Nhật ký</h4>
            <div className="card-tools">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="collapse"
              >
                <i className="fas fa-minus"></i>
              </button>
            </div>
          </div>
        )}

        <div className="card-body col-12">
          <div>
            {log_action &&
              (log_action).map((lAct, idx) => {
                return <p key={idx}>{lAct}</p>;
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(
  (store) => {
    return {
      post: store.post,
    };
  },
  (dispatch) => {
    return {
      setCurrentPost: (value) => {
        dispatch(postActions.setCurrentPost(value));
      },
    };
  }
)(OptionsTab);
